<template>
    <section id="page-actueel-thema" class="page">
        <div class="page__content">
            <h1>Hybride docenten zijn een actueel thema</h1>
            <div id="page-actueel-thema__tekort" class="page__section">
                <p>Als deeloplossing voor het lerarentekort</p>
                <div class="leraren-tekort">
                    <div class="flipper" v-for="i in nmbTeachers">
                        <div class="flipper__wrapper">
                            <div class="flipper__face flipper__face--front">
                                <img src="../../assets/images/docent-vrouw-omtrek-100.png">
                               <!-- <img src="../../assets/images/docent-man-omtrek-50.png>">-->
                            </div>
                            <div class="flipper__face flipper__face--back">
                                <img src="../../assets/images/docent-vrouw-100.png">
                                <!--<img src="../../assets/images/docent-man-50.png>">-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="page-actueel-thema__carriere" class="page__section">
                <p>Als interessante loopbaankeuze voor leraren die meer willen</p>
                <div>
                    <img class="page-actueel-thema__footsteps" src="../../assets/icons/footsteps.svg"
                         v-for="i in nmbFootsteps">
                </div>
            </div>

            <div id="page-actueel-thema__toekomst" class="page__section">
                <p>Als nieuwe invulling van het leraarschap van de toekomst</p>
                <img class="page-actueel-thema__rocket" src="../../assets/icons/rocket.svg">
            </div>
            <div class="page-actueel-thema__next-btn">
                <page-next-button v-on:click="nextHandler"></page-next-button>
            </div>
        </div>

    </section>
</template>
<style lang="stylus">
    #page-actueel-thema
        display inline-block
        .page__section
            opacity 0
            margin-bottom 25px
        .page-next-button
            margin-top -30px

    .leraren-tekort
        padding 0 20%
        .flipper__face img
            height 70px
        .flipper
            margin-bottom 0

    .page-actueel-thema__footsteps
        width 50px
        transform rotate(90deg)
        opacity 0

    #page-actueel-thema__toekomst
        position relative
        overflow hidden

    .page-actueel-thema__rocket
        transform rotate(56deg) scale(.6)
        top -50px
        left calc(-50% - 100px)
        transition left .5s
        position relative
        visibility hidden

    .page-actueel-thema__rocket--ready-for-launch
        visibility visible

    .page-actueel-thema__rocket--launch
        left 0

    .page-actueel-thema__next-btn
        opacity 0

</style>
<script>
    const ScrollMagic = require('ScrollMagic');
    const TimelineMax = require('TimelineMax');
    import page from './page';

    export default {
        mixins: [page],
        data() {
            return {
                nmbTeachers: 8,
                nmbFootsteps: 5
            }
        },
        mounted() {
            let timeline = new TimelineMax();

            /* Animate tekort */
            timeline.to('#page-actueel-thema__tekort', 1, {opacity: 1});

            /* Animate teachers */
            for (let i=0; i < this.nmbTeachers; i++) {
                timeline.to(`#page-actueel-thema .flipper:nth-child(${i+1}) .flipper__wrapper`, .2, {transform: 'rotateY(180deg)'}, '-=.1');
            }

            /* Animate career/footsteps */
            timeline
                .to('#page-actueel-thema__carriere', .7, {opacity: 1});

            for (let i=0; i < this.nmbFootsteps; i++) {
                timeline.to(`.page-actueel-thema__footsteps:nth-child(${i+1})`, .2, {opacity: 1});
            }

            /* Animate rocket */
            timeline
                .to('#page-actueel-thema__toekomst', .7, {opacity: 1})
                .set(".page-actueel-thema__rocket", { className: "+=page-actueel-thema__rocket--ready-for-launch"})
                .set(".page-actueel-thema__rocket", { className: "+=page-actueel-thema__rocket--launch"})


            /* Animate next button */
            timeline.to(".page-actueel-thema__next-btn", .8, {opacity: 1, delay: .5});

            new ScrollMagic.Scene( {
                    triggerElement: '#page-actueel-thema'
                })
                // .setPin('#page-actueel-thema')
                .setTween(timeline)
                .addTo(this.scroller);
        }
    }
</script>



// WEBPACK FOOTER //
// page-actueel-thema.vue?1be03d78